import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { RequestModel } from 'src/app/models/requests';
import { SignatureProvider } from 'src/app/models/signatureProvider';

@Component({
  selector: 'app-performactioncertificateprovider',
  templateUrl: './performactioncertificateprovider.component.html'
})
export class PerformActionCertificateProviderComponent implements OnInit {

  @Input('request') request!: RequestModel;
  @Input('signatureProvider') signatureProvider!: any;
  @Input('signatureProviderName') signatureProviderName!: any;
  @Input('signatureProviders') signatureProviders!: any;
  @Output('newSignMethod') newSignMethod = new EventEmitter();
  
  translations:any = <any>{};
  changedSignatureProvider: any;
  newSignatureProviderName!: string;
  suffix: string = " ";
  newSignatureProvider!: SignatureProvider;
  changedProvider!: string;
  currentProvider!: string;

  constructor(public activeModal: NgbActiveModal, private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  getTranslations() {
    this.translateService.get([
      "Request.View.SigningDialog.ESeal",
      "Request.View.SigningDialog.Token",
      "Request.View.SigningDialog.Test"
    ]).subscribe(translation => {
      this.translations.ESeal = translation['Request.View.SigningDialog.ESeal'];
      this.translations.Token = translation['Request.View.SigningDialog.Token'];
      this.translations.TokenAgent = translation['Request.View.SigningDialog.TokenAgent'];
      this.translations.Test = translation['Request.View.SigningDialog.Test'];
    });
  }

  setSignMethod(provider: any) {
    if (provider !== this.signatureProvider) this.suffix = "";
    
    if (provider.signatureProviderType === 'AdssSignatureProvider') {
      this.changedProvider = this.translations.ESeal;
      if (provider.name.indexOf('Pkisigning_') !== 0) {
        this.suffix = (provider.description.split(",")[0]).split("CN=")[1] ? " ("+(provider.description.split(",")[0]).split("CN=")[1]+")" : "";
      }
    } else if (provider.signatureProviderType === 'TokenCertificateSignatureProvider') {
      this.changedProvider = this.translations.Token;
    } else if (provider.signatureProviderType === 'HardTokenAgentSignatureProvider') {
      this.changedProvider = this.translations.TokenAgent;
    } else {
      this.changedProvider = provider.name;
      if (provider.parameters && provider?.parameters[0].indexOf(this.translations.Test) > -1) {
        this.suffix = this.suffix + " " + this.translations.Test;
      }
    }
    this.newSignatureProviderName = this.changedProvider + this.suffix;
    this.newSignatureProvider = provider;
    this.newSignMethod.emit(this.newSignatureProvider);
  }

}
